<template lang="html">
  <div class="label-box">
    <div class="item" style="border-color: rgb(0, 0, 255);">
      <span style="color: rgb(0, 0, 255);">HC</span>
      <span style="color: rgb(255, 255, 255);">
        褐·长翅
      </span>
    </div>
    <div class="item" style="border-color: rgb(248, 242, 25);">
      <span style="color: rgb(248, 242, 25);">BC</span>
      <span style="color: rgb(255, 255, 255);">
        白背·长翅
      </span>
    </div>
    <div class="item" style="border-color: red;">
      <span style="color: red;">DR</span>
      <span style="color: rgb(255, 255, 255);">低龄</span>
    </div>
    <div class="item" style="border-color: rgb(0, 255, 0);">
      <span style="color: rgb(0, 255, 0);">DC</span>
      <span style="color: rgb(255, 255, 255);">
        褐·短翅
      </span>
    </div>
    <div class="item" style="border-color: rgb(128, 0, 128);">
      <span style="color: rgb(128, 0, 128);">BDC</span>
      <span style="color: rgb(255, 255, 255);">
        白背·短翅
      </span>
    </div>
    <div class="item" style="border-color: rgb(51, 51, 51);">
      <span style="color: rgb(51, 51, 51);">HCH</span>
      <span style="color: rgb(255, 255, 255);">
        灰·长翅
      </span>
    </div>
    <div class="item" style="border-color: rgb(0, 255, 255);">
      <span style="color: rgb(0, 255, 255);">GR</span>
      <span style="color: rgb(255, 255, 255);">
        褐·高龄
      </span>
    </div>
    <div class="item" style="border-color: rgb(128, 0, 0);">
      <span style="color: rgb(128, 0, 0);">BGR</span>
      <span style="color: rgb(255, 255, 255);">
        白背·高龄
      </span>
    </div>
    <div class="item" style="border-color: rgb(204, 255, 204);">
      <span style="color: rgb(204, 255, 204);">HGR</span
      ><span style="color: rgb(255, 255, 255);">灰·高</span>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="css" scoped>
.label-box {
  position: absolute;
  right: 0;
  bottom: 0;
  background-color: #0000001a;
  bottom: 5px;
  right: 0;
  width: 300px;
  display: flex;
  flex-wrap: wrap;
  font-size: 12px;
  padding: 0;
}
.label-box .item {
  width: 30%;
  height: 30%;
  border: 1px solid red;
  margin: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px;
  box-sizing: border-box;
}
</style>
